export default () => ({
  roles: [],
  role: {},
  permissions: {},
});
